import Carousel from "@components/Carousel";
import LBox from "@components/LBox";
import LText from "@components/LText";
import LargeTile from "@components/LargeTile";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";

export type AlbumType = {
  id: string;
  title: string;
  artistDisplayText: string;
  image: string | null;
  releaseDate: string | null;
  hasPrivateSong: boolean;
  privateSongIds: string[];
};

interface AlbumsProps {
  albums: AlbumType[];
  title?: string;
}

const Albums = ({ albums, title = "Releases" }: AlbumsProps) => {
  const screen = useNavigationStore((state) => {
    const path = state.currentPath;
    if (path.includes("home")) return "home";
    if (path.includes("library")) return "library";
    if (path.includes("explore")) return "explore";
    return "home";
  });

  if (albums.length === 0) {
    return null;
  }

  return (
    <LBox gap="m1">
      <LBox paddingHorizontal="s4">
        <LText variant="Heading/H1/Bold">{title}</LText>
      </LBox>
      <Carousel
        data={albums}
        renderItem={({ item: album }) => (
          <LargeTile
            item={album ? { ...album, type: "album" } : undefined}
            screen={screen}
            showReleaseYear
          />
        )}
      />
    </LBox>
  );
};

export default Albums;
